import httpClient from "../http-client";

const getCategory = async (categoryId: string) => {
  const category = (await httpClient.get<any>(`categories/${categoryId}`)).data;

  return category;
};

const getAllCategories = async (filters?: any) => {
  if (filters) {
    for (let param of Object.keys(filters)) {
      if (!filters[param]) {
        delete filters[param];
      }
    }
  }

  const categories = (await httpClient.get<any[]>("categories", { params: filters })).data;

  return categories;
};

const createCategory = async (newCategory: any) => {
  const createCategoryResponse = (
    await httpClient.post<any>(`categories`, newCategory)
  ).data;

  return createCategoryResponse;
};

const updateCategory = async (
  categoryId: string,
  newContentForCategory: any
) => {
  await httpClient.put(`categories/${categoryId}`, newContentForCategory);
};

const deleteCategory = async (categoryId: string) => {
  await httpClient.delete(`categories/${categoryId}`);
};

const activateOrInactivateCategory = async (
  categoryId: any,
  activate: boolean
) => {
  await httpClient.put(`categories/${categoryId}/active`, {
    is_active: activate,
  });
};

export {
  getAllCategories,
  deleteCategory,
  updateCategory,
  createCategory,
  getCategory,
  activateOrInactivateCategory,
};
